import angular from 'angular';
import template from './phone-number.html';

const phoneNumberConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('phoneNumber', {
		title:      'Phone Number',
		template,
		group:      'advanced',
		children:   false,
		selectable: true,
		settings:   {
			autofocus:    false,
			disabled:     false,
			input:        true,
			tableView:    true,
			inputType:    'tel',
			label:        'Phone Number',
			key:          'phonenumber',
			hideLabel:    false,
			placeholder:  '',
			prefix:       '',
			suffix:       '',
			protected:    false,
			persistent:   true,
			hidden:       false,
			defaultValue: '',
			clearOnHide:  true,
			validate:     {
				card: '0-1',
			},
			kdata:        {
				defaults: {
					country: 'FR',
				},
				submit:   true,
			},
		},
		icon: 'fa fa-phone-square',
		views: [
			{
				name:     'Display',
				template: 'kform/components/phone-number/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/textfield/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/phone-number/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
	});
};

export default angular.module('app').config(phoneNumberConfig);
